let plantaActiva = 'planta0';
function mostrarMapaPorPlanta(planta) {
  $('.mapa-tienda').hide(); // Oculta todos
  $(`.mapa-tienda[data-planta="${planta}"]`).show(); // Muestra los de la planta activa
  var imagenPlanta = '';
  if(planta === 'plantam1') {
    imagenPlanta = '1';
  }else{
    imagenPlanta = '0';
  }
  $('.mapa-base').attr('src', `/storage/locales/mapa-general-${imagenPlanta}.png`);
}

// Hover sobre tienda
$(document).on('mouseenter', '.item-galeria', function () {
  var id = this.id.substr(13);
  $(".mapa-tienda").removeClass('activo');
  $(`.mapa-tienda-${id}[data-planta="${plantaActiva}"]`).addClass('activo');

});

document.addEventListener('DOMContentLoaded', () => {
  // Por defecto, mostrar planta 0
  mostrarMapaPorPlanta(plantaActiva);

  // Botón planta -1
  $('.planta-sotano').on('click', function () {
      plantaActiva = 'plantam1';
      mostrarMapaPorPlanta(plantaActiva);
  });

  // Botón planta baja
  $('.planta-baja').on('click', function () {
      plantaActiva = 'planta0';
      mostrarMapaPorPlanta(plantaActiva);
  });

  // Galería scroll lateral
  const track = document.querySelector('.section-galeria-items');
  const prevBtn = document.querySelector('.galeria-prev');
  const nextBtn = document.querySelector('.galeria-next');
  if(prevBtn && nextBtn && track) {
    prevBtn.addEventListener('click', () => {
        track.scrollBy({ left: -300, behavior: 'smooth' });
    });
  
    nextBtn.addEventListener('click', () => {
        track.scrollBy({ left: 300, behavior: 'smooth' });
    });
  }
});
